/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 16:52:59
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { DateTimeFormat } from '../../../models/datetime'
import {
  getTAHLocationDetailAsync,
  getTAHLocationSubmitAsync,
} from './TAHLocationSlice'

const { Option } = Select

export const AddOrEditFormLocationModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  }

  const getDetail = () => {
    dispatch(
      getTAHLocationDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          type: v?.type ? v?.type?.toString() : '',
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      }
    } else {
      form.resetFields()
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={900}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
          form.resetFields()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                }
              : {
                  ...vs,
                }
            dispatch(getTAHLocationSubmitAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='名称'
                name='local'
                rules={[
                  {
                    required: true,
                    message: '温度范围不能为空',
                  },
                ]}
              >
                <Input placeholder='名称' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='类型'
                name='type'
                rules={[
                  {
                    required: true,
                    message: '温度范围不能为空',
                  },
                ]}
              >
                <Select placeholder='类型' allowClear>
                  <Option value='1'>常温</Option>
                  <Option value='2'>阴冷</Option>
                  <Option value='3'>冷藏</Option>
                  <Option value='4'>恒温</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={11} style={{ marginLeft: '26px' }}>
              <Row>
                <Form.Item
                  label='温度范围'
                  name='temperatureRangLow'
                  rules={[
                    {
                      required: true,
                      message: '温度范围不能为空',
                    },
                  ]}
                >
                  <Input
                    placeholder='温度范围'
                    style={{ width: '118px' }}
                    type='number'
                  />
                </Form.Item>
                <span style={{ margin: '6px' }}> - </span>
                <Form.Item
                  label=''
                  name='temperatureRangHight'
                  rules={[
                    {
                      required: true,
                      message: '温度范围不能为空',
                    },
                  ]}
                >
                  <Input
                    placeholder='温度范围'
                    style={{ width: '118px' }}
                    type='number'
                  />
                </Form.Item>
                <span style={{ marginLeft: '6px', marginTop: '5px' }}> ℃ </span>
              </Row>
            </Col>
            <Col span={11} style={{ marginLeft: '40px' }}>
              <Row>
                <Form.Item
                  label='湿度范围'
                  name='humidityRangLow'
                  rules={[
                    {
                      required: true,
                      message: '湿度范围不能为空',
                    },
                    {
                      message: '请输入数字',
                      pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                    },
                  ]}
                >
                  <Input
                    placeholder='湿度范围'
                    style={{ width: '118px' }}
                    type='number'
                  />
                </Form.Item>
                <span style={{ margin: '6px' }}> - </span>
                <Form.Item
                  label=''
                  name='humidityRangHight'
                  rules={[
                    {
                      required: true,
                      message: '湿度范围不能为空',
                    },
                    {
                      message: '请输入数字',
                      pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                    },
                  ]}
                >
                  <Input
                    placeholder='湿度范围'
                    style={{ width: '118px' }}
                    type='number'
                  />
                </Form.Item>
                <div style={{ marginLeft: '6px', marginTop: '5px' }}> % </div>
              </Row>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
